import React         from "react";
import { Container } from "typedi";
import { observer }  from "mobx-react";
import ModalService  from "../../Service/ModalService";

@observer
class ManageModalViewModel extends React.Component<{}, {}> {
    public render(): React.ReactNode {
        return Container.get(ModalService).printLayoutModal() || <></>;
    }
}

export default ManageModalViewModel;
